import React from "react";
import CallButton from "./CallButton";
import DirectionsButton from "./DirectionsButton";
import BusinessHours from "./BusinessHours";
import ReviewSection from "./ReviewSection";

/**
 * Shared conversion block for individual /services/* pages:
 * hours, testimonials, and call / directions CTAs.
 */
export default function ServicePageCta() {
  return (
    <div className="mt-14 space-y-10 border-t border-slate-200 pt-12">
      <BusinessHours tone="light" />
      <ReviewSection tone="light" />
      <div className="flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:justify-center">
        <CallButton className="px-8 py-3 text-base" />
        <DirectionsButton className="px-8 py-3 text-base" />
      </div>
    </div>
  );
}
